import React, { useState, useRef } from 'react';
import cls from 'classnames';

import useWindowSize from '../../utils/useWindowSize';

import Slider from 'react-slick';

import Spreader from '../../Spreader';

import './styles.css';

const ICONS = {
  VOICE: 'Legend__slide-icon--voice',
  SMS: 'Legend__slide-icon--sms',

  VOICE_MAIL: 'Legend__slide-icon--audio-message',
  WAP: 'Legend__slide-icon--wap',
  BROWSER_GAMES: 'Legend__slide-icon--game',
  SIMPLE_SITE: 'Legend__slide-icon--simplesite',
  SITE: 'Legend__slide-icon--site',
  PHOTO_SHARE: 'Legend__slide-icon--photo',
  GPS_TRACKING: 'Legend__slide-icon--gps',
  SMARTPHONES: 'Legend__slide-icon--smartphone',
  I_WANT_PS4: 'Legend__slide-icon--console',
  WATCHES: 'Legend__slide-icon--watch',
  WIFI: 'Legend__slide-icon--wifishare',
  SMART_HOUSE: 'Legend__slide-icon--smhouse',
  SMART_TRANSPORT: 'Legend__slide-icon--car',
  VIDEO: 'Legend__slide-icon--video',
  VR: 'Legend__slide-icon--vr',
  K4: 'Legend__slide-icon--k4',
  IOT: 'Legend__slide-icon--iot',
};

const Slide = props => (
  <div className="Legend__slide">
    <span
      className="Legend__slide-label"
      style={{ backgroundColor: `rgba(148, 36, 241, ${props.opacity})` }}
    >
      {props.title}
    </span>
    <div
      className={cls('Legend__slide-chronology', {
        'Legend__slide-chronology--isFirst': props.isFirst,
      })}
    >
      {props.year}
    </div>
    <div className="Legend__slide-icons">
      {props.icons.map((type, index) => (
        <div className={cls('Legend__slide-icon', type)} key={index} />
      ))}
    </div>
    {props.now}
    <br />
    <b>{props.speed}</b>
  </div>
);

const SLIDE_WIDTH = 300;

export default props => {
  const size = useWindowSize();
  const sliderRef = useRef(null);

  const increase = () => {
    sliderRef.current.slickNext();
    // console.log(sliderRef);
    // bind
  };

  const decrease = () => {
    sliderRef.current.slickPrev();
    // console.log(sliderRef);
    // bind
  };

  const width = Math.min(size.width, 1200);
  const unUsedWidth = width > 700 ? 200 : 0;
  const slidesToShow = ((width - unUsedWidth) / SLIDE_WIDTH) ^ 0;
  console.log('slidesToShow', slidesToShow);
  const settings = {
    arrows: false,
    dots: false,
    appendDots: false,
    lazyLoad: false,
    infinite: false,
    speed: 300,
    slidesToShow,
    slidesToScroll: 1,
    initialSlide: 0,
  };

  return (
    <div className={cls('Legend', props.className)}>
      <Spreader>
        <div className="Legend__inner">
          <div className="MapSliderTrigger">
            <div
              className="MapSliderTrigger__trigger MapSliderTrigger__trigger--isLeft"
              onClick={decrease}
            />
            <div
              className="MapSliderTrigger__trigger MapSliderTrigger__trigger--isRight"
              onClick={increase}
            />
          </div>
          <div className="Legend__slider">
            <Slider {...settings} ref={sliderRef}>
              <Slide
                isFirst
                opacity={0.4}
                title="1G"
                year="1991 год"
                icons={[ICONS.VOICE]}
                now="Что появилось: голосовая связь"
              />
              <Slide
                opacity={0.5}
                title="2G"
                year="1991 год"
                icons={[ICONS.VOICE, ICONS.SMS, ICONS.VOICE_MAIL]}
                speed={'Скорость интернета: 9,6 кбит/с'}
                now="Что появилось: смс, голосовая почта"
              />
              <Slide
                opacity={0.6}
                title="GPRS "
                year="2000 год"
                icons={[ICONS.WAP, ICONS.BROWSER_GAMES, ICONS.SIMPLE_SITE]}
                speed={'Скорость интернета: 32 - 114 Кбит/сек'}
                now="Что появилось: протокол WAP, браузерные игры, просмотр простых сайтов"
              />
              <Slide
                opacity={0.7}
                title="EDGE"
                year="2004 год"
                icons={[ICONS.BROWSER_GAMES, ICONS.SIMPLE_SITE]}
                speed={'Скорость интернета: до 384 Кбит/c'}
              />
              <Slide
                opacity={0.8}
                title="3G"
                year="2007 год"
                icons={[ICONS.SITE, ICONS.PHOTO_SHARE, ICONS.GPS_TRACKING]}
                speed={'Скорость интернета: до 2 Мбит/с'}
                now="Что появилось: просмотр веб-страниц, обмен фото и GPS-отслеживание"
              />
              <Slide
                opacity={0.8}
                title="HSPA"
                year="2010 год"
                icons={[ICONS.VIDEO]}
                speed={'Скорость интернета: до 42 Мбит/с'}
                now="Что появилось: просмотр видео онлайн"
              />
              <Slide
                opacity={0.9}
                title="4G"
                year="2012 год"
                icons={[ICONS.SMARTPHONES, ICONS.I_WANT_PS4, ICONS.WATCHES]}
                speed={'Скорость интернета: до 150 Мбит/c'}
                now="Что появилось: высокоскоростной доступ к медиафайлам, лучшее качество связи и меньшее число сбоев, Full HD-видео"
              />
              <Slide
                opacity={0.9}
                title="LTE-A"
                year="2014 год"
                icons={[ICONS.K4, ICONS.VR]}
                speed={'Скорость интернета: до 1 Гбит/c'}
                now="Что появилось: виртуальная реальность, потоковое видео в разрешении 4K"
              />
              <Slide
                opacity={1}
                title="5G"
                year="2019 год"
                icons={[ICONS.SMART_HOUSE, ICONS.SMART_TRANSPORT, ICONS.IOT]}
                speed={'Скорость интернета: до 20 Гбит/с'}
                now="Что появилось: инфраструктура для технологий будущего – VR/AR, IoT, беспилотный транспорт, телемедицина"
              />
            </Slider>
          </div>
        </div>
      </Spreader>
    </div>
  );
};
